module.exports = __webpack_public_path__ + "static/img/icon_More@2x.2215bad4.png";